import React from 'react'
import PropTypes from 'prop-types'

const LoadingStateText = ({ isLoading, loadingText, text }) =>
  isLoading ? (
    <span>
      {loadingText} <i className="fa icon fa-circle-notch fa-spin" />
    </span>
  ) : (
    text
  )

LoadingStateText.propTypes = {
  isLoading: PropTypes.bool,
  loadingText: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node, PropTypes.string])
    .isRequired,
  text: PropTypes.oneOfType([PropTypes.elementType, PropTypes.node, PropTypes.string]).isRequired,
}
LoadingStateText.defaultProps = {
  isLoading: false,
}

export default LoadingStateText
